import * as datasources from "./common_metadata/datasource"

export class PropertyTypes {
    public static get OBJECTEXT(): string { return "OBJECTEXT"; }
    public static get CHECKBOX(): string { return "CHECKBOX"; }
    public static get TEXT(): string { return "TEXT"; }
    public static get OBJECT_LIST_EXT(): string { return "OBJECT_LIST_EXT"; }
    public static get TRANSLATIONPICKER(): string { return "TRANSLATIONPICKER"; }
    public static get SELECT(): string { return "SELECT"; }
    public static get SERVICESELECTOR(): string { return "SERVICESELECTOR"; }
    public static get COLUMNPICKER(): string { return "COLUMNPICKER"; }
    public static get TEMPLATEEDITOR(): string { return "TEMPLATEEDITOR"; }
    public static get ENTITYFIELDPICKER(): string { return "ENTITYFIELDPICKER"; }
    public static get FONTAWESOMEICON(): string { return "FONTAWESOMEPICKER"; }
    public static get TEXTCHECKBOX(): string { return "PROPERTYSWITCHER"; }
    public static get DICTIONARYEDITOR(): string { return "DICTIONARYEDITOR"; }
    public static get STATISTICPROPERTY(): string { return "STATISTICPROPERTY"; }
    public static get NOTEDITABLEPROPERTY(): string { return "NOTEDITABLEPROPERTY"; }
    public static get DOCUMENTPICKER(): string { return "DOCUMENTPICKER"; }
    public static get UNIQUEQUESTIONID(): string { return "UNIQUEQUESTIONID"; }
    public static get TRANSLATABLETEXTARRAYPROPERTY(): string { return "TRANSLATABLETEXTARRAYPROPERTY"; }
    public static get REACTTEMPLATEPROPERTY(): string { return "REACTTEMPLATEPROPERTY"; }
}

export interface componentMetadata {
    getMetadata(): BaseProperty[];
    hydrateFromJS(object: any);
};

export class InstanceLoader {
    static getInstance(context: any, name: string, ...args: any[]): componentMetadata {
        var instance = new context(args);
        return instance as componentMetadata;
    }
}

export var WidthProperty = {
    Type: PropertyTypes.SELECT, ValueField: "width", Label: "Width", Options: [
        { Key: "1", Value: "1" },
        { Key: "2", Value: "2" },
        { Key: "3", Value: "3" },
        { Key: "4", Value: "4" },
        { Key: "5", Value: "5" },
        { Key: "6", Value: "6" },
        { Key: "7", Value: "7" },
        { Key: "8", Value: "8" },
        { Key: "9", Value: "9" },
        { Key: "10", Value: "10" },
        { Key: "11", Value: "11" },
        { Key: "12", Value: "12" }
    ]
}

export abstract class BaseProperty {
    public Type: string;
    public ValueField;
    public IsMandatory: boolean;

    constructor(type: string) {
        this.Type = type;
    }

    public SetMandatory(mandatory: boolean) {
        this.IsMandatory = mandatory;
        return this;
    }

    fromJS(value: any) {
        return value;
    }
}

export class TextPropertyBase extends BaseProperty {
    public Label;

    constructor(propertyType: string, valueField: string, label: string) {
        super(propertyType);
        this.ValueField = valueField;
        this.Label = label;
    }
}

export class TextProperty extends TextPropertyBase {
    public OnlyUpperCase: boolean;

    public IsReadOnly: boolean;

    public OnlyNumbers: boolean;

    constructor(valueField: string, label: string, toUpper?: boolean) {
        super(PropertyTypes.TEXT, valueField, label);
        this.OnlyUpperCase = toUpper;
    }

    public SetReadonly(readonly: boolean): TextProperty {
        this.IsReadOnly = readonly;
        return this;
    }

    public SetOnlyNumbers(readonly: boolean): TextProperty {
        this.OnlyNumbers = readonly;
        return this;
    }
}

export class TranslatableTextArrayProperty extends TextPropertyBase {

    public IsReadOnly: boolean;

    public OnlyNumbers: boolean;

    public LanguageFieldName: string;

    public TranslationFieldName: string;

    constructor(valueField: string, label: string, languageFieldName: string, translationFieldName: string) {
        super(PropertyTypes.TRANSLATABLETEXTARRAYPROPERTY, valueField, label);
        this.TranslationFieldName = translationFieldName;
        this.LanguageFieldName = languageFieldName;
    }

    public SetReadonly(readonly: boolean): TranslatableTextArrayProperty {
        this.IsReadOnly = readonly;
        return this;
    }

    public SetOnlyNumbers(readonly: boolean): TranslatableTextArrayProperty {
        this.OnlyNumbers = readonly;
        return this;
    }
}

export class EntityFieldProperty extends TextPropertyBase {

    constructor(valueField: string, label: string) {
        super(PropertyTypes.ENTITYFIELDPICKER, valueField, label);
    }
}

export class DocumentIdProperty extends TextPropertyBase {

    constructor(valueField: string, label: string) {
        super(PropertyTypes.DOCUMENTPICKER, valueField, label);
    }
}

export class FontawesomeIconProperty extends TextPropertyBase {

    constructor(valueField: string, label: string) {
        super(PropertyTypes.FONTAWESOMEICON, valueField, label);
    }
}

export enum DataSourceType {
    sql = 0,
    hierarchicalSql = 1
}

export class ServiceSelectorProperty extends BaseProperty {
    public Label: string;
    public Export: boolean;
    public DataSourceType: DataSourceType;
    public UseOnlyServiceId: boolean = false;

    constructor(valueField: string, label: string, isExport: boolean, dataSourceType: DataSourceType) {
        super(PropertyTypes.SERVICESELECTOR);
        this.ValueField = valueField;
        this.Label = label;
        this.Export = isExport;
        this.DataSourceType = dataSourceType;
    }
}

export class TranslatableTextProperty extends TextPropertyBase {
    constructor(valueField: string, label: string) {
        super(PropertyTypes.TRANSLATIONPICKER, valueField, label);
    }
}

export class ColumnProperty extends TextPropertyBase {
    public ServiceProperty: string;
    private dataSource: () => datasources.Datasource;

    public getDataSource(): datasources.Datasource {
        return this.dataSource && this.dataSource();
    }
    constructor(valueField: string, label: string, serviceProperty: string, dataSource?: () => datasources.Datasource) {
        super(PropertyTypes.COLUMNPICKER, valueField, label);
        this.ServiceProperty = serviceProperty;
        this.getDataSource = dataSource;
    }
}



export class TextCheckboxProperty extends TextPropertyBase {
    constructor(valueField: string, label: string) {
        super(PropertyTypes.TEXTCHECKBOX, valueField, label);
    }
}

export class DictionaryProperty extends TextPropertyBase {
    constructor(valueField: string, label: string) {
        super(PropertyTypes.DICTIONARYEDITOR, valueField, label);
    }
}

export class StatisticProperty extends TextPropertyBase {
    constructor(valueField: string, label: string) {
        super(PropertyTypes.STATISTICPROPERTY, valueField, label);
    }
}

export class TemplateProperty extends TextPropertyBase {
    constructor(valueField: string, label: string) {
        super(PropertyTypes.TEMPLATEEDITOR, valueField, label);
    }
}

export class CheckBoxProperty extends TextPropertyBase {
    public DefaultValue: boolean;
    constructor(valueField: string, label: string, defaultValue: boolean = false) {
        super(PropertyTypes.CHECKBOX, valueField, label);
        this.DefaultValue = defaultValue;
    }
}

export class SelectProperty extends TextPropertyBase {
    public Options: { Key: string | number, Value: string | number }[] = [];

    constructor(valueField: string, label: string) {
        super(PropertyTypes.SELECT, valueField, label);
    }

    public addOption(key: string | number, value: string | number): SelectProperty {
        this.Options.push({ Key: key, Value: value });
        return this;
    }
}

export class NotEditableProperty extends BaseProperty {
    constructor(valueField: string, label: string) {
        super(PropertyTypes.NOTEDITABLEPROPERTY);
        this.ValueField = valueField;
    }
}


export class ReactTemplateProperty extends TextPropertyBase {
    constructor(valueField: string, label: string) {
        super(PropertyTypes.REACTTEMPLATEPROPERTY, valueField, label);
    }
}

export abstract class Serializable {
    abstract getMetadata(): BaseProperty[];
    hydrateFromJS(object) {
        if (object) {
            for (let meta of this.getMetadata()) {
                this[meta.ValueField] = meta.fromJS(object[meta.ValueField]);
            }
        }
    }

    public toJSON() {
        var result = {};
        const meta = this.getMetadata();
        for (var x of meta) {
            if (x.Type == PropertyTypes.OBJECTEXT && this[x.ValueField] && this[x.ValueField].toJSON) {
                result[x.ValueField] = this[x.ValueField].toJSON();
            }
            else if (x.Type == PropertyTypes.OBJECT_LIST_EXT && this[x.ValueField]) {
                const objectTypeField = x["objectTypeField"];
                result[x.ValueField] = this[x.ValueField].map((x) => {
                    if (x.toJSON) {
                        const json = x.toJSON();
                        if (x[objectTypeField]) {
                            json[objectTypeField] = x[objectTypeField];
                        }
                        return json;
                    }
                    return x;
                });
            }
            else {
                if (this[x.ValueField] != null) {
                    result[x.ValueField] = this[x.ValueField];
                }
            }
        }
        if (this["_Object_Type"]) {
            result["_Object_Type"] = this["_Object_Type"];
        }

        return result;
    };
}

export class ObjectPropertyExt extends TextPropertyBase {
    private stateImplementations: { [key: string]: typeof Serializable } = {};
    private firstStateImplementation: typeof Serializable;
    public RenderInline: boolean;

    fromJS(value: any) {
        if (!value) {
            return null;
        }
        const stateImpl = this.stateImplementations[value["_Object_Type"]] || this.stateImplementations[this.getAllKeys()[0]]
        if (!stateImpl) {
            return null;
        }
        let instance = InstanceLoader.getInstance(stateImpl, null, null);
        instance.hydrateFromJS(value);
        instance["_Object_Type"] = value["_Object_Type"];
        return instance;
    }

    constructor(valueField, label) {
        super(PropertyTypes.OBJECTEXT, valueField, label);
    }

    addStateImplementation(key: string, stateImplementation: typeof Serializable): ObjectPropertyExt {
        if (this.getAllKeys().length === 0) {
            this.firstStateImplementation = stateImplementation;
        }
        this.stateImplementations[key] = stateImplementation;
        return this;
    }

    getStateImplementation(key: string) {
        const impl = this.stateImplementations[key];

        if (!impl) {
            return this.firstStateImplementation;
        }

        return impl;
    }

    getAllKeys(): string[] {
        return Object.keys(this.stateImplementations);
    }

    createNewStateImplementationInstance(key: string) {
        const stateImpl = this.getStateImplementation(key);
        const instance = InstanceLoader.getInstance(stateImpl, null, null);
        instance["_Object_Type"] = key;

        return instance;
    }
}

export class ObjectListPropertyExt extends TextPropertyBase {
    private stateImplementations: { [key: string]: typeof Serializable } = {};
    private firstStateImplementation: typeof Serializable;
    public objectTypeField: string = "_Object_Type";
    public IsReadOnly: boolean;

    fromJS(arrayOfObjects: any[]) {
        const newArray = [];
        if (!arrayOfObjects && !Array.isArray(arrayOfObjects)) {
            return null;
        }

        for (var obj of arrayOfObjects) {
            const stateImpl = this.stateImplementations[obj[this.objectTypeField]] || this.stateImplementations[this.getAllKeys()[0]];
            if (!stateImpl) {
                return null;
            }
            let instance = InstanceLoader.getInstance(stateImpl, null, null);
            instance.hydrateFromJS(obj);
            instance[this.objectTypeField] = obj[this.objectTypeField];
            newArray.push(instance);
        }

        return newArray;
    }


    constructor(valueField, label, objectTypeField: string = "_Object_Type") {
        super(PropertyTypes.OBJECT_LIST_EXT, valueField, label);
        this.objectTypeField = objectTypeField;
    }

    addStateImplementation(key: string, stateImplementation: typeof Serializable): ObjectListPropertyExt {
        if (this.getAllKeys().length === 0) {
            this.firstStateImplementation = stateImplementation;
        }
        this.stateImplementations[key] = stateImplementation;
        return this;
    }

    getStateImplementation(key: string) {
        const impl = this.stateImplementations[key];

        if (!impl) {
            return this.firstStateImplementation;
        }

        return impl;
    }

    getAllKeys(): string[] {
        return Object.keys(this.stateImplementations);
    }

    createNewStateImplementationInstance(key: string) {
        const stateImpl = this.getStateImplementation(key);
        if (stateImpl) {
            const instance = InstanceLoader.getInstance(stateImpl, null, null);
            instance[this.objectTypeField] = key;
            return instance;
        }
    }
}

var WidthPropertyMetadata = new SelectProperty("width", "Width");
for (let i = 1; i <= 12; i++) {
    let istr = i.toString();
    WidthPropertyMetadata.addOption(istr, istr);
}

export abstract class BaseComponentProps extends Serializable {
    private nameMetadata = new TextProperty("name", "Name", true);
    public name: string;
    private uidMetadata = new TextProperty("uid", "Uid").SetReadonly(true);
    public uid: string;
    public width: number;
    private baseComponentMetadata: BaseProperty[];

    constructor() {
        super();
        this.baseComponentMetadata = [this.uidMetadata, this.nameMetadata, WidthPropertyMetadata];
    }

    getMetadata(): BaseProperty[] {
        return this.baseComponentMetadata;
    };

    getNameMetadata(): TextProperty {
        return this.nameMetadata;
    }

    hasErrors(): boolean {
        const meta = this.getMetadata();

        for (let x of meta) {
            let value = this[x.ValueField];

            if (x.IsMandatory && !value) {
                return true;
            }
        }
        return false;
    }
};

export abstract class AppBaseComponentProps extends Serializable {
    private nameMetadata = new TranslatableTextProperty("name", "Name");
    public name: string;

    private uidMetadata = new TextProperty("guid", "Guid").SetReadonly(true);
    public uid: string;

    private modelMetadata = new EntityFieldProperty("model", "Model");
    public model: string;

    private readOnlyMetadata = new TextCheckboxProperty("readOnly", "Read only");
    public readOnly: string;

    private visibleMetadata = new CheckBoxProperty("visible", "Visible");
    public visible: string;

    private requiredMetadata = new CheckBoxProperty("required", "Required");
    public required: string;

    private labelAndControlCombinedMetadata = new CheckBoxProperty("labelAndControlCombined", "Label and control combined");
    public labelAndControlCombined: string;

    private visibleConditionMetadata = new TextProperty("visibleCondition", "Visible condition");
    public visibleCondition: string;

    private leftContainerStyleMetadata = new DictionaryProperty("leftContainerStyle", "Left container style");
    public leftContainerStyle: string;

    private rightContainerStyleMetadata = new DictionaryProperty("rightContainerStyle", "Right container style");
    public rightContainerStyle: string;

    private defaultValueMetadata = new TextProperty("defaultValue", "Default value");
    public defaultValue: string;

    private isKeyMetadata = new CheckBoxProperty("isKey", "Is key");
    public isKey: string;

    private dataSourceMetadata = new TextProperty("dataSource", "Data source");
    public dataSource: string;

    private titleMetadata = new TextProperty("title", "Title");
    public title: string;

    private defaultValueModifierMetadata = new TextProperty("defaultValueModifier", "Default value modifier");
    public defaultValueModifier: string;

    private baseComponentMetadata: BaseProperty[];

    constructor() {
        super();
        this.baseComponentMetadata = [this.uidMetadata, this.nameMetadata, this.modelMetadata, this.readOnlyMetadata,
        this.visibleMetadata, this.visibleConditionMetadata, this.requiredMetadata, this.labelAndControlCombinedMetadata,
        this.leftContainerStyleMetadata, this.rightContainerStyleMetadata, this.defaultValueMetadata,
        this.isKeyMetadata, this.dataSourceMetadata, this.titleMetadata, this.defaultValueModifierMetadata
        ];
    }

    getMetadata(): BaseProperty[] {
        return this.baseComponentMetadata;
    };

    hasErrors(): boolean {
        const meta = this.getMetadata();

        for (let x of meta) {
            let value = this[x.ValueField];

            if (x.IsMandatory && !value) {
                return true;
            }
        }
        return false;
    }
};

export abstract class AppDataSourceBaseComponentProps extends AppBaseComponentProps {
    private dataSourceUrlMetadata = new TemplateProperty("dataSourceUrl", "DataSource url");
    public dataSourceUrl: string;

    private dataTextFieldMetadata = new TextProperty("dataTextField", "Data text field");
    public dataTextField: string;

    private dataValueFieldMetadata = new TextProperty("dataValueField", "Data value field");
    public dataValueField: string;

    private allMetadataDataSource: BaseProperty[];

    constructor() {
        super();
        this.allMetadataDataSource = super.getMetadata().concat([this.dataSourceUrlMetadata, this.dataTextFieldMetadata, this.dataValueFieldMetadata]);
    }

    getMetadata(): BaseProperty[] {
        return this.allMetadataDataSource;
    };
}